// ESM-Huelle fuer lib/scripts/CLS_CMover.js (ESM-Welle 4d).
// Originalquelltext unveraendert uebernommen; nur der Export ist neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.

function CMover()
{
    this.currentMover =
    {
        xDif: 0,
        yDif: 0,
        active: false,
        id: ""
    }
}

CMover.prototype.set = function(element, id)
{
    element.setAttribute("moverId", id);
    element.onmousedown = POS.mover.startMove;
}

CMover.prototype.startMove = function(event)
{
    var cls = POS.mover;
    
    var moverId = event.target.getAttribute ("moverId");
    
    if (moverId != event.target.id)
        return;

    event.target.onmousemove = cls.moveHandler;
    event.target.onmouseup = cls.stopMove;

    var x = parseFloat(event.target.style.left);
    var y = parseFloat(event.target.style.top);
    
    cls.currentMover.active = true;
    cls.currentMover.id = event.target.id;
    cls.currentMover.xDif = event.pageX - x;
    cls.currentMover.yDif = event.pageY - y;
}

CMover.prototype.moveHandler = function (event)
{
    var cls = POS.mover;
    
    if (cls.currentMover.active != true)
        return;
    
    var element = document.getElementById(cls.currentMover.id);
    
    var newX = event.pageX - cls.currentMover.xDif;
    var newY = event.pageY - cls.currentMover.yDif;
    element.style.left = newX + "px";
    element.style.top = newY + "px";
}

CMover.prototype.stopMove = function (event)
{
    var cls = POS.mover;
    
    cls.currentMover.active = false;
    cls.currentMover.id = "";
    cls.currentMover.xDif = 0;
    cls.currentMover.yDif = 0;
    
    event.target.onmousemove = null;
    event.target.onmouseup = null;
    event.target.onmousedown = cls.startMove;
}
export { CMover };
